/* eslint-disable @typescript-eslint/no-explicit-any */
function isUTMSearchParam(paramName: string) {
  return paramName.toLowerCase().startsWith('utm_')
}
export const toSearchParams = (object: Record<string, any>) => {
  const searchParams = new URLSearchParams(Object.entries(object).filter(([_, value]) => value !== undefined))
  return searchParams
}

export const getShareURL = (url: string, utmParams: Record<string, any> = {}) => {
  if (!url) return url
  const urlWithSchema = url.startsWith('http') ? url : `https://${url}`
  const u = new URL(urlWithSchema)
  u.searchParams.forEach((_, name, params) => {
    if (!isUTMSearchParam(name)) return
    params.delete(name)
  })
  const utmSearchParams = toSearchParams(utmParams)

  utmSearchParams.forEach((value, name) => u.searchParams.set(name, value))
  return u.toString()
}

export const encodeShareURL = (url: string, utmParams: Record<string, any> = {}, prefix = '') => {
  const u = getShareURL(url, utmParams)
  return encodeURIComponent(prefix + u)
}

export const openPopup = (url: string) => window.open(url, 'sharer', 'toolbar=no,width=1042,height=436')

export const copyToClipboard = (value: string) => {
  const tempEl = document.createElement('textarea')
  tempEl.value = value
  document.body.appendChild(tempEl)
  tempEl.select()
  const success = document.execCommand('copy')
  document.body.removeChild(tempEl)

  if (!success) {
    const locale = document.documentElement.lang || 'de'
    const alertMessage =
      locale === 'de'
        ? 'Sorry, dein Browser unterstützt diese Funktion nicht.'
        : "Sorry, your Browser doesn't support this feature."
    alert(alertMessage)
  }

  return success
}

export const isMobileOrTablet = () => {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent)
}
